module.exports = __webpack_public_path__ + "static/contact-flower-d0905cbbb597b04b236a04507b1df1e6.svg";